export const KEY_CODES = {
  space: 32,
  left: 37,
  right: 39,
  up: 38,
  down: 40,
  f: 70,
  h: 72,
  m: 77
};